/**
 * Показ z-оценки: общий для всех теневых подсистем.
 *
 * # Почему модуль, а не функция в каждой панели
 *
 * Вопрос «есть ли кромка» у всех подсистем один и тот же: доля угаданного
 * сравнивается с ценой входа, и объявляется это ЗАПАСОМ В СИГМАХ, а не знаком
 * разности. Планка «зелёное только от двух сигм» — это утверждение о том, чему
 * мы верим, и оно обязано быть одним на весь экран: разъехавшись, две копии
 * покрасили бы одно и то же число по-разному в соседних панелях.
 *
 * Сам z считает СЕРВЕР (см. webapi.zScore) — здесь только показ. Вторая
 * реализация формулы в браузере разошлась бы с первой молча.
 */

/**
 * z-оценка словами. Прочерк — «считать не из чего», и это НЕ ноль: ноль
 * читался бы как «измерили и получили ровно среднее».
 */
export function zWord(z: number | null | undefined): string {
  if (z === null || z === undefined) return "—";
  const sign = z > 0 ? "+" : z < 0 ? "−" : "";
  return `${sign}${Math.abs(z).toFixed(1)}σ`;
}

/**
 * Цвет z-оценки. Зелёный — ТОЛЬКО от двух сигм: на меньшем разница неотличима
 * от случайной, и красить её значило бы обещать кромку там, где её нет.
 *
 * Планка не выдумана: |z| ≤ 1.1 на каждом шаге подбора уже давал +$177 к PnL на
 * той же выборке, по которой фильтры и подбирались.
 */
export function zTone(z: number | null | undefined): string | undefined {
  if (z === null || z === undefined) return undefined;
  if (z >= 2) return "var(--color-good)";
  if (z <= -2) return "var(--color-bad)";
  return undefined;
}
